import { useEffect, useRef, useState } from "react";

const stats = [
  { value: "2008", label: "Año de Establecimiento", icon: "ri-building-4-fill" },
  { value: "350+", label: "Piscinas Completadas", icon: "ri-water-flash-fill" },
  { value: "120+", label: "Hidromasajes completados", icon: "ri-drop-fill" },
  { value: "15+", label: "Proyectos por entregar", icon: "ri-hammer-fill" },
];

function useCountUp(target: number, duration = 1500, start = false) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!start) return;
    let startTime: number | null = null;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * target));
      if (progress < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }, [target, duration, start]);
  return count;
}

export default function Stats() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-20 bg-teal-700">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((s) => (
            <div key={s.label} className="text-center">
              <div className="w-14 h-14 bg-teal-500/40 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${s.icon} text-teal-100 text-2xl`} />
              </div>
              <p className="text-4xl font-black text-white">{s.value}</p>
              <p className="text-teal-200 text-xs font-semibold tracking-wide mt-2 leading-tight">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
